import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dod-pipeline/artifacts/q2rbbxv3_transparent.png";

// variant="light" renders the dark navy mark as white for use on dark navy backgrounds.
export function Logo({ variant = "dark", className = "" }) {
  const style = variant === "light" ? { filter: "brightness(0) invert(1)" } : undefined;
  return (
    <img
      src={LOGO_URL}
      alt="ComplyX Gov"
      style={style}
      className={className}
      data-testid="complyx-logo"
    />
  );
}

// Full lockup: logo mark + "Gov" wordmark suffix (reads "ComplyX Gov").
export function LogoLockup({ variant = "dark", size = "md", showTagline = false }) {
  const light = variant === "light";
  const heights = { sm: "h-10", md: "h-12", lg: "h-16" };
  return (
    <div className="flex items-center gap-3">
      <Logo variant={variant} className={`${heights[size]} w-auto`} />
      <div className={`flex flex-col justify-center border-l ${light ? "border-white/25" : "border-navy/15"} pl-3 leading-none`}>
        <span className={`font-display font-bold tracking-tight ${light ? "text-white" : "text-navy"} ${size === "lg" ? "text-2xl" : "text-lg"}`}>
          Gov
        </span>
        {showTagline && (
          <span className="text-[10px] uppercase tracking-[0.2em] text-gold mt-1">Command Center</span>
        )}
      </div>
    </div>
  );
}
